import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomPhoneInput from "../../../CustomControls/CustomPhoneInput";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomMultiSelect from "../../../CustomControls/CustomMultiSelect";

import img200 from "../../../../images/avatar/DefaultUserPhoto.jpg";
import { SVGICON } from "../../../constant/theme";
import QuickAddCategory from "../Categories/QuickAddCategory";
import {
  POST_GetCategoryDropDownListByCategoryType,
  POST_BranchDDLList,
  POST_RoleDDLList,
  POST_GetEmployeeDetailByID,
  POST_EmployeeInsert,
  POST_EmployeeUpdate,
  POST_ValidateLicenseLimit,
  POST_GetDepartmentDropDownList,
  POST_GetMaterialCategoryDropDownListByCategoryType,
} from "../../../helpers/url_helper";
import { post, postFormData } from "../../../helpers/api_helper";
import moment from "moment";
import {
  capitalizeString,
  delete_RecordWithoutApi,
  errorMessage,
  successMessage,
  validateEmailField,
  validateMobileNoField,
  warningMessage,
} from "../CommonFunctions";

const AddEmployee = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  const [country, setCountry] = useState("");

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const [showQuickAddCategoryModal, setShowQuickAddCategoryModal] =
    useState(false);
  const [categoryType, setCategoryType] = useState(0);
  const [parentCategoryID, setParentCategoryID] = useState(0);
  const [categoryTypeName, setCategoryTypeName] = useState("");

  const [roleOptions, setRoleOptions] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [designationOptions, setDesignationOptions] = useState([]);
  // const [idProofOptions, setIDProofOptions] = useState([]);
  const [relationOptions, setRelationOptions] = useState([]);
  const [testingDepartmentOptions, setTestingDepartmentOptions] = useState([]);

  const [employeePhoto, setEmployeePhoto] = useState(null);
  const [employeePhotoFile, setEmployeePhotoFile] = useState(null);

  const [empStemp, setEmpStemp] = useState(null);
  const [empStempFile, setEmpStempFile] = useState(null);

  const [addIDProofImageModal, setAddIDProofImageModal] = useState(false);
  const [addEmergencyContactModal, setAddEmergencyContactModal] =
    useState(false);
  const [addQualificationModal, setAddQualificationModal] = useState(false);
  const [testGroupOptions, setTestGroupOptions] = useState([]);

  const genderOptions = [
    { label: "Male", value: 1 },
    { label: "Female", value: 2 },
    { label: "Transgender", value: 3 },
  ];

  const getDepartmentDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 4, // 4 = Department
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDepartmentOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );

          /*select the value when there is only one option while insert only*/
          if (response?.List?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue("DepartmentID", response?.List[0].CategoryID);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getDesignationDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 5, // 5 = Designation
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDesignationOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );

          /*select the value when there is only one option while insert only*/
          if (response?.List?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue("DesignationID", response?.List[0].CategoryID);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getRelationDDL = async () => {
    setIsLoading(true);
    await post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 6, // 6 = Relation
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setRelationOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // const getIDProofDDL = async () => {
  //   setIsLoading(true);
  //   await post(POST_GetCategoryDropDownListByCategoryType, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //     CategoryType: 7, // 7 = IDProof
  //     ParentCategoryID: 0,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setIDProofOptions(
  //           response?.List?.map((item) => ({
  //             label: item.CategoryName,
  //             value: item.CategoryID,
  //           }))
  //         );
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const getRoleDDL = async () => {
    setIsLoading(true);
    await post(POST_RoleDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setRoleOptions(
            response?.List?.map((item) => ({
              label: item.RoleName,
              value: item.RoleIDEncrypt,
            })),
          );

          /*select the value when there is only one option while insert only*/
          if (response?.List?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue("RoleIDs", [
              {
                label: response?.List[0].RoleName,
                value: response?.List[0].RoleIDEncrypt,
              },
            ]);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getBranchDDL = async () => {
    setIsLoading(true);
    await post(POST_BranchDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      EmployeeIDEncrypted: "",
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setBranchOptions(
            response?.BranchList?.map((item) => ({
              label: item.BranchName,
              value: item.BranchIDEncrypted,
              IsBranchDefinationComplate: item.IsBranchDefinationComplate,
            })),
          );

          /*select the value when there is only one option while insert only*/
          if (response?.BranchList?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue("BranchIDs", [
              {
                label: response?.BranchList[0].BranchName,
                value: response?.BranchList[0].BranchIDEncrypted,
              },
            ]);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTestingDepartmentDDL = async () => {
    setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTestingDepartmentOptions(
            response?.List?.map((item) => ({
              label: item.DepartmentName,
              value: item.DepartmentIDEncrypted,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getTestGroupDDL = async () => {
    setIsLoading(true);
    await post(POST_GetMaterialCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 4, // 4 = Test Group
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setTestGroupOptions(
            response?.List?.map((item) => ({
              label: item?.CategoryName,
              value: item?.MaterialCategoryIDEncrypted,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchema = Yup.object().shape({
    EmployeeName: Yup.string()
      .trim()
      .required("Employee Name is required field"),

    UserName: Yup.string().trim().required("Username is required field"),
    DesignationID: Yup.string().required("Designation is required field"),
    DepartmentID: Yup.string().required("Department is required field"),
    RoleIDs: Yup.array()
      .required("Role is required field")
      .min(1, "Role is required field")
      .nullable(),
    // BranchIDs: Yup.array().required("Branch is required field").nullable(),
    BranchIDs: Yup.array()
      .required("Branch is required field")
      .min(1, "Branch is required field")
      .nullable(),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      EmployeeIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      EmployeeName: "",
      Address: "",
      CountryCode: "+91",
      MobileNo: "",
      MobileNoFormat: "",
      EmailID: "",
      DateOfJoining: "",
      DesignationID: "",
      DepartmentID: "",
      DateOfBirth: "",
      Gender: "",
      AuthorizedSignatory: false,
      RoleIDs: "",
      BranchIDs: "",
      EmployeePhoto: "",
      EmpSignStemp: "",
      UserName: "",
      // IDProofType: "",
      // IDProofNo: "",
      ListEmployeeEmergencyContacts: [],
      ListEmpQualifications: [],
      ListEmployeeIDProofDoc: [],
      IsActive: true,
      EmployeePhotoURL: "",
      EmpSignStempURL: "",
      TestingDepartmentIDs: "",
      TestGroupIDs: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      CountryCode,
      AuthorizedSignatory,
      ListEmployeeIDProofDoc,
      ListEmployeeEmergencyContacts,
      ListEmpQualifications,
      //IDProofType,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    if (
      !validateMobileNoField(
        values?.MobileNoFormat,
        CountryCode,
        values?.MobileNo,
      )
    ) {
      formik.setFieldError("MobileNo", "Please enter a valid mobile number");
      formik.setFieldTouched("MobileNo", true);
      return false;
    }
    setIsLoading(true);

    let formData = new FormData();
    formData.append("EmployeeIDEncrypt", values?.EmployeeIDEncrypt);
    formData.append("EmployeeName", values?.EmployeeName);
    formData.append("Address", values?.Address);
    formData.append("CountryCode", "+" + CountryCode.replace(/\+/g, ""));
    formData.append("MobileNo", values?.MobileNo);
    formData.append("EmailID", values?.EmailID);
    formData.append(
      "DateOfJoining",
      values?.DateOfJoining
        ? moment(values?.DateOfJoining).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
    );
    formData.append(
      "DateOfBirth",
      values?.DateOfBirth
        ? moment(values?.DateOfBirth).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
    );
    formData.append(
      "DesignationID",
      values?.DesignationID ? values?.DesignationID : 0,
    );
    formData.append(
      "DepartmentID",
      values?.DepartmentID ? values?.DepartmentID : 0,
    );
    formData.append("Gender", values?.Gender);
    formData.append("AuthorizedSignatory", values?.AuthorizedSignatory);
    formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);
    formData.append(
      "RoleIDs",
      Array.from(values.RoleIDs, (x) => x.value).join(","),
    );
    formData.append(
      "BranchIDs",
      Array.from(values.BranchIDs, (x) => x.value).join(","),
    );
    formData.append(
      "TestingDepartmentIDs",
      Array.from(values.TestingDepartmentIDs, (x) => x.value).join(","),
    );
    formData.append(
      "TestGroupIDs",
      Array.from(values.TestGroupIDs, (x) => x.value).join(","),
    );
    formData.append("UserName", values?.UserName);
    formData.append(
      "CreatedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );
    formData.append(
      "ModifiedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );

    formData.append("EmployeePhotoURL", values?.EmployeePhotoURL);
    formData.append("EmpSignStempURL", values?.EmpSignStempURL);
    formData.append("EmployeePhoto", employeePhotoFile);
    formData.append("EmpSignStemp", empStempFile);
    formData.append("SendEmailPermissions", AuthUser?.Permissions?.Email);

    values?.ListEmployeeEmergencyContacts?.map((x, i) => {
      formData.append(
        `ListEmployeeEmergencyContacts[${i}].ContactPersonName`,
        x.ContactPersonName,
      );
      formData.append(
        `ListEmployeeEmergencyContacts[${i}].RelationID`,
        x.RelationID,
      );
      formData.append(
        `ListEmployeeEmergencyContacts[${i}].CountryCode`,
        x.CountryCode,
      );
      formData.append(
        `ListEmployeeEmergencyContacts[${i}].MobileNo`,
        x.MobileNo,
      );
    });

    values?.ListEmpQualifications?.map((x, i) => {
      formData.append(`ListEmpQualifications[${i}].Degree`, x.Degree);
    });

    values?.ListEmployeeIDProofDoc?.map((x, i) => {
      formData.append(
        `ListEmployeeIDProofDoc[${i}].IDProofName`,
        x.IDProofName,
      );
      formData.append(
        `ListEmployeeIDProofDoc[${i}].IDProofImage`,
        x.IDProofImage,
      );
      formData.append(
        `ListEmployeeIDProofDoc[${i}].IDProofImageUrl`,
        x.IDProofImageUrl,
      );
    });

    postFormData(
      PrimaryIdParam ? POST_EmployeeUpdate : POST_EmployeeInsert,
      formData,
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          // swal("Success!", response?.Message, "success");
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/employee");
          }, 1000);
        } else {
          //  swal("Error!", response?.Message, "error");
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (PrimaryIdParam) {
      getRoleDDL();
      getDepartmentDDL();
      getDesignationDDL();
      // getIDProofDDL();
      getBranchDDL();
      getRelationDDL();
      getTestingDepartmentDDL();
      getTestGroupDDL();
      getEmployeeDetails();
    } else {
      validateLicenseLimit();
    }
  }, []);

  const validateLicenseLimit = async () => {
    setIsLoading(true);
    await post(POST_ValidateLicenseLimit, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      LoginIDEncrypted: AuthUser?.LoginIDEncrypt,
      FormNo: 9, //Employee
    })
      .then((response) => {
        if (response?.IsSuccess == false) {
          // navigate("/employee");
          navigate(-1);
        } else {
          getRoleDDL();
          getDepartmentDDL();
          getDesignationDDL();
          // getIDProofDDL();
          getBranchDDL();
          getRelationDDL();
          getTestingDepartmentDDL();
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getEmployeeDetails = () => {
    setIsLoading(true);
    post(POST_GetEmployeeDetailByID, {
      EmployeeIDEncrypted: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          let listRoles = response?.ListOfRoles;
          let listBranches = response?.ListOfBranches;
          let listDepartments = response?.ListOfTestingDepartments;
          let listTestGroup = response?.ListOfTestGroup;

          formik.setValues({
            ...response,
            EmployeeIDEncrypt: window.atob(PrimaryIdParam),
            Gender: response?.Gender ? parseInt(response?.Gender) : "",
            ListEmployeeEmergencyContacts:
              response?.ListOfEmployeeEmergencyContacts?.map((x) => ({
                ...x,
                CountryCodeEmergency: x.CountryCode,
              })),
            ListEmpQualifications: response?.ListOfEmpQualificationDetails,
            ListEmployeeIDProofDoc: response?.ListOfEmployeeIDProofDoc?.map(
              (x) => ({
                ...x,
                IDProofImageUrl: x.IDProofImage,
                IDProofImagePreview: x.IDProofImage,
                IDProofImage: "",
              }),
            ),
            DateOfBirth: response?.DateOfBirth
              ? new Date(response.DateOfBirth)
              : "",
            DateOfJoining: response?.DateOfJoining
              ? new Date(response.DateOfJoining)
              : "",
            UserName: response?.EmployeeLoginID,
            RoleIDs:
              listRoles.length > 0
                ? listRoles.map((x) => ({
                    label: x.RoleName,
                    value: x.RoleIDEncrypt,
                  }))
                : "",
            BranchIDs:
              listBranches.length > 0
                ? listBranches.map((x) => ({
                    label: x.BranchName,
                    value: x.BranchIDEncrypt,
                  }))
                : "",
            TestingDepartmentIDs:
              listDepartments.length > 0
                ? listDepartments.map((x) => ({
                    label: x.DepartmentName,
                    value: x.DepartmentIDEncrypted,
                  }))
                : "",
            TestGroupIDs:
              listTestGroup.length > 0
                ? listTestGroup.map((x) => ({
                    label: x.TestGroup,
                    value: x.TestGroupIDEncrypted,
                  }))
                : "",
          });
          if (response?.EmployeePhoto) {
            setEmployeePhoto(response.EmployeePhoto);
          }
          if (response?.EmpSignStemp) {
            setEmpStemp(response.EmpSignStemp);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallbackQuickAddCategory = (categoryID, categoryName) => {
    if (categoryType == 4) {
      // 4 = Department
      setDepartmentOptions([
        ...departmentOptions,
        { label: categoryName, value: categoryID },
      ]);
      formik.setFieldValue("DepartmentID", categoryID);
    } else if (categoryType == 5) {
      // 5 = Designation
      setDesignationOptions([
        ...designationOptions,
        { label: categoryName, value: categoryID },
      ]);
      formik.setFieldValue("DesignationID", categoryID);
    } else if (categoryType == 6) {
      // 6 = Relation
      setRelationOptions([
        ...relationOptions,
        { label: categoryName, value: categoryID },
      ]);

      formikEmergencyContact.setFieldValue("RelationID", categoryID);
    }
    // else if (categoryType == 7) {
    //   // 7 = ID Proof
    //   setIDProofOptions([
    //     ...idProofOptions,
    //     { label: categoryName, value: categoryID },
    //   ]);
    //   formik.setFieldValue("IDProofType", categoryID);
    // }
  };

  const uploadEmployeePhoto = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /image-*/;
      if (!file.type.match(pattern)) {
        setEmployeePhotoFile(null);
        setEmployeePhoto(null);
        // swal("", "Select valid image file!", "warning");
        warningMessage("Select valid image file!");
      } else {
        // var reader = new FileReader();
        // reader.readAsDataURL(e.target.files[0]);
        // reader.onload = function (e) {
        //   var image = new Image();
        //   image.src = e.target.result;
        //   image.onload = function () {
        //     var height = this.height;
        //     var width = this.width;
        // if (height !== 200 || width !== 200) {
        //   swal("Error!", "Image size must be of 200x120", "error");
        //   setEmployeePhotoFile(null);
        //   setEmployeePhoto(null);
        // } else {
        setEmployeePhotoFile(file);
        setEmployeePhoto(URL.createObjectURL(file));
        // }
        //   };
        // };
      }
      formik.setFieldValue("EmployeePhotoURL", "");
    }
  };

  const uploadEmpStemp = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /image-*/;
      if (!file.type.match(pattern)) {
        setEmpStempFile(null);
        setEmpStemp(null);
        //  swal("", "Select valid image file!", "warning");
        warningMessage("Select valid image file!");
      } else {
        // var reader = new FileReader();
        // reader.readAsDataURL(e.target.files[0]);
        // reader.onload = function (e) {
        //   var image = new Image();
        //   image.src = e.target.result;
        //   image.onload = function () {
        //     var height = this.height;
        //     var width = this.width;
        // if (height !== 200 || width !== 200) {
        //   swal("Error!", "Image size must be of 200x120", "error");
        //   setEmpStempFile(null);
        //   setEmpStemp(null);
        // } else {
        setEmpStempFile(file);
        setEmpStemp(URL.createObjectURL(file));
        // }
        //   };
        // };
      }
      formik.setFieldValue("EmpSignStempURL", "");
    }
  };

  const validationSchemaIDProofImage = Yup.object().shape({
    IDProofImage: Yup.string()
      .trim()
      .required("ID Proof Image is required field"),
    IDProofName: Yup.string().trim().required("Name is required field"),
  });

  const formikIDProofImage = useFormik({
    validationSchema: validationSchemaIDProofImage,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitIDProofImage(values, formikHelpers),
    initialValues: {
      IDProofImage: "",
      IDProofImagePreview: "",
      IDProofName: "",
      IDProofImageUrl: "",
      indx: "",
      actionFlagIDProof: 0, // 0 = Add,  1 = edit
    },
    validateOnBlur: false,
  });

  const {
    values: { actionFlagIDProof },
  } = formikIDProofImage;

  const handleValidSubmitIDProofImage = (values) => {
    if (values?.indx !== "") {
      formik.setFieldValue(
        "ListEmployeeIDProofDoc",
        ListEmployeeIDProofDoc?.map((x, idx) => {
          if (idx == values?.indx) {
            return {
              ...x,
              IDProofImage: values?.IDProofImage,
              IDProofImagePreview: values?.IDProofImagePreview,
              IDProofName: values?.IDProofName,
              IDProofImageUrl: values?.IDProofImageUrl,
            };
          } else {
            return { ...x };
          }
        }),
      );
    } else {
      formik.setFieldValue("ListEmployeeIDProofDoc", [
        ...ListEmployeeIDProofDoc,
        {
          ...values,
          IDProofImageUrl: "",
        },
      ]);
    }
    setAddIDProofImageModal(false);
  };

  const addIDProofImage = () => {
    formikIDProofImage.resetForm();
    setAddIDProofImageModal(true);
  };

  // const editIDProofImage = (i) => {
  //   formikIDProofImage.setValues({
  //     ...ListEmployeeIDProofDoc?.filter((x, idx) => idx == i)[0],
  //     indx: i,
  //   });
  //   formikIDProofImage.setFieldValue("actionFlagIDProof", 1); // 1 = edit
  //   setAddIDProofImageModal(true);
  // };

  const deleteIDProofImage = (i) => {
    formik.setFieldValue(
      "ListEmployeeIDProofDoc",
      ListEmployeeIDProofDoc?.filter((x, idx) => idx != i),
    );
  };

  const uploadIdProofImage = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /image-*/;
      if (!file.type.match(pattern)) {
        formikIDProofImage.setFieldValue("IDProofImage", "");
        formikIDProofImage.setFieldValue("IDProofImagePreview", "");
        //swal("", "Select valid image file!", "warning");
        warningMessage("Select valid image file!");
      } else {
        formikIDProofImage.setFieldValue("IDProofImage", file);
        formikIDProofImage.setFieldValue(
          "IDProofImagePreview",
          URL.createObjectURL(file),
        );
        formikIDProofImage.setFieldError("IDProofImage", "");
      }
      formikIDProofImage.setFieldValue("IDProofImageUrl", "");
    }
  };

  const validationSchemaEmergencyContact = Yup.object().shape({
    ContactPersonName: Yup.string().trim().required("Name is required field"),
    RelationID: Yup.string().required("Relation is required field"),
    MobileNo: Yup.string().trim().required("Contact No is required field"),
  });

  const formikEmergencyContact = useFormik({
    validationSchema: validationSchemaEmergencyContact,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitEmergencyContact(values, formikHelpers),
    initialValues: {
      ContactPersonName: "",
      RelationID: "",
      RelationName: "",
      CountryCodeEmergency: "+91",
      MobileNo: "",
      MobileNoFormat: "",
      indx: "",
      actionFlagEmergencyContact: 0, // 0 = Add,  1 = edit
    },
    validateOnBlur: false,
  });

  const {
    values: { actionFlagEmergencyContact, CountryCodeEmergency },
  } = formikEmergencyContact;

  const handleValidSubmitEmergencyContact = (values) => {
    if (
      !validateMobileNoField(
        values?.MobileNoFormat,
        CountryCodeEmergency,
        values?.MobileNo,
      )
    ) {
      formikEmergencyContact.setFieldError(
        "MobileNo",
        "Please enter a valid mobile number",
      );
      formikEmergencyContact.setFieldTouched("MobileNo", true);
      return false;
    }

    if (values?.indx !== "") {
      formik.setFieldValue(
        "ListEmployeeEmergencyContacts",
        ListEmployeeEmergencyContacts?.map((x, idx) => {
          if (idx == values?.indx) {
            return {
              ...x,
              ContactPersonName: values?.ContactPersonName,
              RelationID: values?.RelationID,
              RelationName: values?.RelationName,
              CountryCode:
                "+" + values?.CountryCodeEmergency.replace(/\+/g, ""),
              MobileNo: values?.MobileNo,
              CountryCodeEmergency:
                "+" + values?.CountryCodeEmergency.replace(/\+/g, ""),
            };
          } else {
            return { ...x };
          }
        }),
      );
    } else {
      formik.setFieldValue("ListEmployeeEmergencyContacts", [
        ...ListEmployeeEmergencyContacts,
        {
          ...values,
          CountryCode: "+" + values?.CountryCodeEmergency.replace(/\+/g, ""),
        },
      ]);
    }
    setAddEmergencyContactModal(false);
  };

  const addEmergencyContact = () => {
    formikEmergencyContact.resetForm();
    /*select the value when there is only one option while insert only*/
    if (relationOptions?.length == 1) {
      formikEmergencyContact.setFieldValue(
        "RelationID",
        relationOptions[0].value,
      );
      formikEmergencyContact.setFieldValue(
        "RelationName",
        relationOptions[0].label,
      );
    }
    setAddEmergencyContactModal(true);
  };

  const editEmergencyContact = (i) => {
    formikEmergencyContact.setValues({
      ...ListEmployeeEmergencyContacts?.filter((x, idx) => idx == i)[0],
      indx: i,
    });
    formikEmergencyContact.setFieldValue("actionFlagEmergencyContact", 1); // 1 = edit
    setAddEmergencyContactModal(true);
  };

  const deleteEmergencyContact = (i) => {
    formik.setFieldValue(
      "ListEmployeeEmergencyContacts",
      ListEmployeeEmergencyContacts?.filter((x, idx) => idx != i),
    );
  };

  const validationSchemaQualification = Yup.object().shape({
    Degree: Yup.string().trim().required("Degree is required field"),
    //Percentage: Yup.number().required("Percentage is required field"),
  });

  const formikQualification = useFormik({
    validationSchema: validationSchemaQualification,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitQualification(values, formikHelpers),
    initialValues: {
      Degree: "",
      //Percentage: "",
      indx: "",
      actionFlagQualification: 0, // 0 = Add,  1 = edit
    },
    validateOnBlur: false,
  });

  const {
    values: { actionFlagQualification },
  } = formikQualification;

  const handleValidSubmitQualification = (values) => {
    if (values?.indx !== "") {
      formik.setFieldValue(
        "ListEmpQualifications",
        ListEmpQualifications?.map((x, idx) => {
          if (idx == values?.indx) {
            return {
              ...x,
              Degree: values?.Degree,
              //Percentage: values?.Percentage,
            };
          } else {
            return { ...x };
          }
        }),
      );
    } else {
      formik.setFieldValue("ListEmpQualifications", [
        ...ListEmpQualifications,
        {
          ...values,
        },
      ]);
    }
    setAddQualificationModal(false);
  };

  const addQualification = () => {
    formikQualification.resetForm();
    setAddQualificationModal(true);
  };

  const editQualification = (i) => {
    formikQualification.setValues({
      ...ListEmpQualifications?.filter((x, idx) => idx == i)[0],
      indx: i,
    });
    formikQualification.setFieldValue("actionFlagQualification", 1); // 1 = edit
    setAddQualificationModal(true);
  };

  const deleteQualification = (i) => {
    formik.setFieldValue(
      "ListEmpQualifications",
      ListEmpQualifications?.filter((x, idx) => idx != i),
    );
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <div className="d-flex justify-content-between align-items-center">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} Employee
              </h4>
              {AuthUser?.IsBroadcastEmailSetup == false &&
                AuthUser?.Permissions?.Email == 1 && (
                  <div className="text-danger">
                    Note: In Application setup - Broadcast Message Mail Setting
                    is pending. So user wan't be able to get credential
                    email.{" "}
                  </div>
                )}
            </div>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={6}>
                    <div className="card mb-2" style={{ height: "auto" }}>
                      <div className="card-body p-2">
                        <Row>
                          <Col lg={6}>
                            <Field
                              label="Employee Name"
                              name="EmployeeName"
                              placeholder={"Enter Employee Name"}
                              component={CustomInput}
                              required
                              maxLength={100}
                              autoFocus
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "EmployeeName",
                                  capitalizeString(e?.target?.value),
                                );
                              }}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Gender"
                              name="Gender"
                              placeholder={"Select Gender"}
                              component={CustomSelect}
                              options={genderOptions}
                              isClearable={false}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Role"
                              name="RoleIDs"
                              placeholder={"Select Role"}
                              component={CustomMultiSelect}
                              options={roleOptions}
                              isMulti={true}
                              required
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Username"
                              name="UserName"
                              placeholder={"Enter Username"}
                              component={CustomInput}
                              required
                              maxLength={100}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              type="email"
                              label="Email"
                              name="EmailID"
                              placeholder={"Enter Email"}
                              component={CustomInput}
                              maxLength={100}
                              validate={validateEmailField}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Mobile No"
                              name="MobileNo"
                              placeholder={"Enter Mobile No"}
                              country={country}
                              countryCode={CountryCode}
                              component={CustomPhoneInput}
                              onChange={(value, { countryCode, dialCode }) => {
                                formik.setFieldValue("CountryCode", dialCode);
                                formik.setFieldValue(
                                  "MobileNo",
                                  value.substring(dialCode.toString().length),
                                );
                              }}
                              onFocus={(value, { format }) => {
                                formik.setFieldValue("MobileNoFormat", format);
                              }}
                            />
                          </Col>
                          <Col lg={6}>
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter((x) => x?.FormID == 7 && x?.IsAdd)
                              ?.length > 0 ? (
                              <Link
                                to="#"
                                className="icon-box icon-box-md bg-primary-light me-1"
                                title="New Designation"
                                style={{ float: "right" }}
                                onClick={() => {
                                  setCategoryType(5); // 5 = Designation
                                  setCategoryTypeName("Designation");
                                  setParentCategoryID(0);
                                  setShowQuickAddCategoryModal(true);
                                }}
                              >
                                <i className="fa fa-plus"></i>
                              </Link>
                            ) : (
                              ""
                            )}
                            <Field
                              label="Designation"
                              name="DesignationID"
                              placeholder={"Select Designation"}
                              component={CustomSelect}
                              options={designationOptions}
                              required
                            />
                          </Col>
                          <Col lg={6}>
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter((x) => x?.FormID == 7 && x?.IsAdd)
                              ?.length > 0 ? (
                              <Link
                                to="#"
                                className="icon-box icon-box-md bg-primary-light me-1"
                                title="New Department"
                                style={{ float: "right" }}
                                onClick={() => {
                                  setCategoryType(4); // 4 = Department
                                  setCategoryTypeName("Department");
                                  setParentCategoryID(0);
                                  setShowQuickAddCategoryModal(true);
                                }}
                              >
                                <i className="fa fa-plus"></i>
                              </Link>
                            ) : (
                              ""
                            )}
                            <Field
                              label="Department"
                              name="DepartmentID"
                              placeholder={"Select Department"}
                              component={CustomSelect}
                              options={departmentOptions}
                              required
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Date Of Birth"
                              name="DateOfBirth"
                              placeholder={"Select Date Of Birth"}
                              component={CustomFlatpickr}
                              options={{
                                altInput: true,
                                altFormat: "j-M-Y",
                                dateFormat: "d-m-Y",
                                maxDate: new Date(),
                              }}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="Date Of Joining"
                              name="DateOfJoining"
                              placeholder={"Select Date Of Joining"}
                              component={CustomFlatpickr}
                              options={{
                                altInput: true,
                                altFormat: "j-M-Y",
                                dateFormat: "d-m-Y",
                              }}
                            />
                          </Col>
                          {/* <Col lg={6}>
                            <Link
                              to="#"
                              className="icon-box icon-box-md bg-primary-light me-1"
                              title="New ID Proof Type"
                              style={{ float: "right" }}
                              onClick={() => {
                                setCategoryType(7); // 7 = ID Proof
                                setCategoryTypeName("ID Proof");
                                setParentCategoryID(0);
                                setShowQuickAddCategoryModal(true);
                              }}
                            >
                              <i className="fa fa-plus"></i>
                            </Link>
                             <Field
                              label="ID Proof Type"
                              name="IDProofType"
                              placeholder={"Select ID Proof Type"}
                              component={CustomSelect}
                              options={idProofOptions}
                            />
                          </Col>
                          <Col lg={6}>
                            <Field
                              label="ID Proof No"
                              name="IDProofNo"
                              placeholder={"Enter ID Proof No"}
                              component={CustomInput}
                              maxLength={50}
                            />
                          </Col> */}
                          <Col lg={6}>
                            <Field
                              label="Address"
                              name="Address"
                              placeholder={"Enter Address"}
                              component={CustomTextArea}
                              rows={5}
                              maxLength={500}
                            />
                          </Col>
                          <Col lg={6}>
                            <label className="mb-1">Authorized Signatory</label>
                            <div className="mb-2 form-control form-control-sm">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="AuthorizedSignatory"
                                name="AuthorizedSignatory"
                                checked={AuthorizedSignatory}
                                onChange={(e) => {
                                  formik.setFieldValue(
                                    "AuthorizedSignatory",
                                    e.target.checked,
                                  );
                                }}
                              />
                              <label
                                className="form-check-label ms-2"
                                htmlFor="AuthorizedSignatory"
                              >
                                Authorized Signatory
                              </label>
                            </div>
                          </Col>
                          <Col lg={12}>
                            <Field
                              label="Branch"
                              name="BranchIDs"
                              placeholder={"Select Branch"}
                              component={CustomMultiSelect}
                              options={branchOptions}
                              isMulti={true}
                              required
                            />
                          </Col>
                          <Col lg={12}>
                            <Field
                              label="Testing Department"
                              name="TestingDepartmentIDs"
                              placeholder={"Select Department"}
                              component={CustomMultiSelect}
                              options={testingDepartmentOptions}
                              isMulti={true}
                            />
                          </Col>
                          {/* <Col lg={12}>
                            <Field
                              label="Test Group"
                              name="TestGroupIDs"
                              placeholder={"Select Test Group"}
                              component={CustomMultiSelect}
                              options={testGroupOptions}
                              isMulti={true}
                            />
                          </Col> */}
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <Row>
                      <Col lg={12}>
                        <div className="card mb-2" style={{ height: "auto" }}>
                          <div className="card-body p-2">
                            <Row>
                              <Col lg={6}>
                                <label className="mb-1">
                                  Employee Photo
                                  {/* <span className="text-danger">*</span>*/}
                                  {/* {" "}
                                  <span className="text-danger fs-12">(200 x 200)</span> */}
                                </label>
                                <div className="image-placeholder square-placeholder">
                                  <div className="avatar-edit">
                                    <input
                                      type="file"
                                      id="imageUpload"
                                      accept="image/png, image/gif, image/jpeg"
                                      onChange={uploadEmployeePhoto}
                                    />
                                    <label
                                      htmlFor="imageUpload"
                                      name=""
                                    ></label>
                                  </div>
                                  <div
                                    id="removeFile"
                                    className="avatar-delete"
                                    onClick={() => {
                                      setEmployeePhotoFile(null);
                                      setEmployeePhoto(null);
                                      formik.setFieldValue(
                                        "EmployeePhotoURL",
                                        "",
                                      );
                                    }}
                                  >
                                    <label htmlFor="removeFile" name=""></label>
                                  </div>
                                  <div className="avatar-preview">
                                    <div id="imagePreview">
                                      <img
                                        id="saveImageFile"
                                        src={
                                          employeePhoto ? employeePhoto : img200
                                        }
                                        alt={"Employee Photo"}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </Col>
                              <Col lg={6}>
                                <label className="mb-1">
                                  Employee Stemp
                                  {/* <span className="text-danger">*</span>*/}
                                  {/* {" "}
                                  <span className="text-danger fs-12">(200 x 200)</span> */}
                                </label>
                                {/* <div className="image-placeholder square-placeholder"> */}
                                <div className="image-placeholder square-placeholder">
                                  <div className="avatar-edit">
                                    <input
                                      type="file"
                                      id="imageUploadStemp"
                                      accept="image/png, image/gif, image/jpeg"
                                      onChange={uploadEmpStemp}
                                    />
                                    <label
                                      htmlFor="imageUploadStemp"
                                      name=""
                                    ></label>
                                  </div>
                                  <div
                                    id="removeFileStemp"
                                    className="avatar-delete"
                                    onClick={() => {
                                      setEmpStempFile(null);
                                      setEmpStemp(null);
                                      formik.setFieldValue(
                                        "EmpSignStempURL",
                                        "",
                                      );
                                    }}
                                  >
                                    <label
                                      htmlFor="removeFileStemp"
                                      name=""
                                    ></label>
                                  </div>
                                  <div className="avatar-preview">
                                    <div id="imagePreviewStemp">
                                      <img
                                        id="saveImageFileStemp"
                                        src={empStemp ? empStemp : img200}
                                        alt={"Employee Stemp"}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {/* {IDProofType ? ( */}
                    <Row>
                      <Col lg={12}>
                        <div className="card mb-2" style={{ height: "auto" }}>
                          <div className="card-body p-2">
                            <div className="d-flex justify-content-between mb-1">
                              <label>ID Proof</label>
                              <Link
                                to="#"
                                className="text-primary"
                                onClick={addIDProofImage}
                              >
                                + Add ID Proof
                              </Link>
                            </div>
                            <div className="table-responsive active-projects style-1 shorting mb-2">
                              <div
                                id="EmployeeIDProofDoc-tbl_wrapper"
                                className="dataTables_wrapper no-footer"
                              >
                                <table
                                  id="EmployeeIDProofDoc-tbl"
                                  className="table dataTable no-footer mb-0"
                                >
                                  <thead>
                                    <tr>
                                      <th width="4%"></th>
                                      <th width="50%">Preview</th>
                                      <th
                                        width="46%"
                                        style={{ textAlign: "left" }}
                                      >
                                        Name
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {ListEmployeeIDProofDoc?.length > 0 ? (
                                      ListEmployeeIDProofDoc?.map(
                                        (item, indx) => (
                                          <tr>
                                            <td>
                                              {/* <Link
                                                to="#"
                                                className="icon-box icon-box-md bg-primary-light me-1"
                                                title="Edit"
                                                onClick={() => {
                                                  editIDProofImage(indx);
                                                }}
                                              >
                                                {SVGICON.EditPrimary}
                                              </Link> */}
                                              <Link
                                                to="#"
                                                // className="icon-box icon-box-md bg-primary-light me-1"
                                                className="icon-box icon-box-md me-1"
                                                title="Download"
                                                onClick={() => {
                                                  window.open(
                                                    item.IDProofImagePreview,
                                                    "_blank",
                                                  );
                                                }}
                                              >
                                                <i className="fa fa-download"></i>
                                              </Link>
                                              <Link
                                                to="#"
                                                // className="icon-box icon-box-md bg-danger-light"
                                                className="icon-box icon-box-md me-1"
                                                title="Delete"
                                                onClick={() => {
                                                  //deleteIDProofImage(indx);
                                                  delete_RecordWithoutApi(
                                                    deleteIDProofImage,
                                                    indx,
                                                  );
                                                }}
                                              >
                                                {SVGICON.DeleteDanger}
                                              </Link>
                                            </td>
                                            <td>
                                              <div
                                                className="image-placeholder"
                                                style={{
                                                  maxWidth: "100px",
                                                  margin: "10px",
                                                  zIndex: 0,
                                                }}
                                              >
                                                <div
                                                  className="avatar-preview"
                                                  style={{
                                                    width: "100px",
                                                    height: "auto",
                                                  }}
                                                >
                                                  <div id="imagePreviewIDProof">
                                                    <img
                                                      id="saveImageFileIDProof"
                                                      src={
                                                        item.IDProofImagePreview
                                                      }
                                                      alt={"ID Proof"}
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                            <td style={{ textAlign: "left" }}>
                                              {item.IDProofName}
                                            </td>
                                          </tr>
                                        ),
                                      )
                                    ) : (
                                      <tr>
                                        <td
                                          colSpan={3}
                                          style={{ textAlign: "left" }}
                                        >
                                          <div>{"No Record Found..."}</div>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    {/* ) : (
                      ""
                    )} */}
                    <Row>
                      <Col lg={12}>
                        <div className="card mb-2" style={{ height: "auto" }}>
                          <div className="card-body p-2">
                            <div className="d-flex justify-content-between mb-1">
                              <label>Emergency Contacts</label>
                              <Link
                                to="#"
                                className="text-primary"
                                onClick={addEmergencyContact}
                              >
                                + Add Emergency Contact
                              </Link>
                            </div>
                            <div className="table-responsive active-projects style-1 shorting mb-2">
                              <div
                                id="EmergencyContact-tbl_wrapper"
                                className="dataTables_wrapper no-footer"
                              >
                                <table
                                  id="EmergencyContact-tbl"
                                  className="table dataTable no-footer mb-0"
                                >
                                  <thead>
                                    <tr>
                                      <th width="4%"></th>
                                      <th width="36%">Name</th>
                                      <th width="30%">Relation</th>
                                      <th
                                        width="30%"
                                        style={{ textAlign: "left" }}
                                      >
                                        Contact No
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {ListEmployeeEmergencyContacts?.length >
                                    0 ? (
                                      ListEmployeeEmergencyContacts?.map(
                                        (item, indx) => (
                                          <tr>
                                            <td>
                                              <Link
                                                to="#"
                                                // className="icon-box icon-box-md bg-primary-light me-1"
                                                className="icon-box icon-box-md me-1"
                                                title="Edit"
                                                onClick={() => {
                                                  editEmergencyContact(indx);
                                                }}
                                              >
                                                {SVGICON.EditPrimary}
                                              </Link>
                                              <Link
                                                to="#"
                                                // className="icon-box icon-box-md bg-danger-light"
                                                className="icon-box icon-box-md me-1"
                                                title="Delete"
                                                onClick={() => {
                                                  //deleteEmergencyContact(indx);
                                                  delete_RecordWithoutApi(
                                                    deleteEmergencyContact,
                                                    indx,
                                                  );
                                                }}
                                              >
                                                {SVGICON.DeleteDanger}
                                              </Link>
                                            </td>
                                            <td>{item.ContactPersonName}</td>
                                            <td>{item.RelationName}</td>
                                            <td style={{ textAlign: "left" }}>
                                              {item.CountryCode} {item.MobileNo}
                                            </td>
                                          </tr>
                                        ),
                                      )
                                    ) : (
                                      <tr>
                                        <td
                                          colSpan={4}
                                          style={{ textAlign: "left" }}
                                        >
                                          <div>{"No Record Found..."}</div>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <div className="card mb-2" style={{ height: "auto" }}>
                          <div className="card-body p-2">
                            <div className="d-flex justify-content-between mb-1">
                              <label>Qualification Details</label>
                              <Link
                                to="#"
                                className="text-primary"
                                onClick={addQualification}
                              >
                                + Add Qualification
                              </Link>
                            </div>
                            <div className="table-responsive active-projects style-1 shorting mb-2">
                              <div
                                id="Qualification-tbl_wrapper"
                                className="dataTables_wrapper no-footer"
                              >
                                <table
                                  id="Qualification-tbl"
                                  className="table dataTable no-footer mb-0"
                                >
                                  <thead>
                                    <tr>
                                      <th width="4%"></th>
                                      <th
                                        width="96%"
                                        style={{ textAlign: "left" }}
                                      >
                                        Degree
                                      </th>
                                      {/* <th
                                        width="40%"
                                        style={{ textAlign: "left" }}
                                      >
                                        Percentage (%)
                                      </th> */}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {ListEmpQualifications?.length > 0 ? (
                                      ListEmpQualifications?.map(
                                        (item, indx) => (
                                          <tr>
                                            <td>
                                              <Link
                                                to="#"
                                                // className="icon-box icon-box-md bg-primary-light me-1"
                                                className="icon-box icon-box-md me-1"
                                                title="Edit"
                                                onClick={() => {
                                                  editQualification(indx);
                                                }}
                                              >
                                                {SVGICON.EditPrimary}
                                              </Link>
                                              <Link
                                                to="#"
                                                // className="icon-box icon-box-md bg-danger-light"
                                                className="icon-box icon-box-md me-1"
                                                title="Delete"
                                                onClick={() => {
                                                  //deleteQualification(indx);
                                                  delete_RecordWithoutApi(
                                                    deleteQualification,
                                                    indx,
                                                  );
                                                }}
                                              >
                                                {SVGICON.DeleteDanger}
                                              </Link>
                                            </td>
                                            <td style={{ textAlign: "left" }}>
                                              {item.Degree}
                                            </td>
                                            {/* <td style={{ textAlign: "left" }}>
                                              {item.Percentage} %
                                            </td> */}
                                          </tr>
                                        ),
                                      )
                                    ) : (
                                      <tr>
                                        <td
                                          colSpan={3}
                                          style={{ textAlign: "left" }}
                                        >
                                          <div>{"No Record Found..."}</div>
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <hr className="mt-1 mb-2"></hr>
                <button
                  type="submit"
                  // className="btn btn-primary"
                  className="btn btn-primary btn-sm me-2"
                >
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  // className="btn btn-danger light"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
        <QuickAddCategory
          categoryType={categoryType}
          parentCategoryID={parentCategoryID}
          showModal={showQuickAddCategoryModal}
          setShowModal={setShowQuickAddCategoryModal}
          categoryTypeName={categoryTypeName}
          fnCallback={fnCallbackQuickAddCategory}
        />
        <Modal
          className="fade"
          show={addIDProofImageModal}
          onHide={setAddIDProofImageModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikIDProofImage}>
              <Form onSubmit={formikIDProofImage.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>ID Proof</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setAddIDProofImageModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div className="mb-2">
                        <label className="mb-1">
                          ID Proof Image <span className="text-danger">*</span>
                        </label>
                        <input
                          type="file"
                          id="IDProofImage"
                          accept="image/png, image/gif, image/jpeg"
                          className="form-control form-control-sm"
                          onChange={uploadIdProofImage}
                        />
                        <ErrorMessage
                          name="IDProofImage"
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                        {/* <label htmlFor="IDProofImage" name=""></label> */}
                      </div>
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="Name"
                        name="IDProofName"
                        placeholder={"Enter Name"}
                        component={CustomInput}
                        maxLength={100}
                        required
                        onChange={(e) => {
                          formikIDProofImage.setFieldValue(
                            "IDProofName",
                            capitalizeString(e?.target?.value),
                          );
                        }}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // variant="primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i>{" "}
                    {actionFlagIDProof == 1 ? "Update" : "Add"}
                  </Button>
                  <Button
                    // variant="danger light"
                    variant="danger btn-sm"
                    onClick={() => setAddIDProofImageModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={addEmergencyContactModal}
          onHide={setAddEmergencyContactModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikEmergencyContact}>
              <Form onSubmit={formikEmergencyContact.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Emergency Contact</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setAddEmergencyContactModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        label="Name"
                        name="ContactPersonName"
                        placeholder={"Enter Name"}
                        component={CustomInput}
                        maxLength={100}
                        required
                        onChange={(e) => {
                          formikEmergencyContact.setFieldValue(
                            "ContactPersonName",
                            capitalizeString(e?.target?.value),
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      {AuthUser?.UserType !== 1 ||
                      formsList?.filter((x) => x?.FormID == 7 && x?.IsAdd)
                        ?.length > 0 ? (
                        <Link
                          to="#"
                          className="icon-box icon-box-md bg-primary-light me-1"
                          title="New Relation"
                          style={{ float: "right" }}
                          onClick={() => {
                            setCategoryType(6); // 6 = Relation
                            setCategoryTypeName("Relation");
                            setParentCategoryID(0);
                            setShowQuickAddCategoryModal(true);
                          }}
                        >
                          <i className="fa fa-plus"></i>
                        </Link>
                      ) : (
                        ""
                      )}
                      <Field
                        label="Relation"
                        name="RelationID"
                        placeholder={"Select Relation"}
                        component={CustomSelect}
                        options={relationOptions}
                        required
                        onChange={(e) => {
                          formikEmergencyContact.setFieldValue(
                            "RelationID",
                            e?.value ?? "",
                          );
                          formikEmergencyContact.setFieldValue(
                            "RelationName",
                            e?.label ?? "",
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="Contact No"
                        name="MobileNo"
                        placeholder={"Enter Contact No"}
                        country={country}
                        countryCode={CountryCodeEmergency}
                        component={CustomPhoneInput}
                        onChange={(value, { countryCode, dialCode }) => {
                          formikEmergencyContact.setFieldValue(
                            "CountryCodeEmergency",
                            dialCode,
                          );
                          formikEmergencyContact.setFieldValue(
                            "MobileNo",
                            value.substring(dialCode.toString().length),
                          );
                        }}
                        onFocus={(value, { format }) => {
                          formikEmergencyContact.setFieldValue(
                            "MobileNoFormat",
                            format,
                          );
                        }}
                        required
                      />
                    </Col>
                  </Row>
                  {showQuickAddCategoryModal == true && (
                    <div className="fade modal-backdrop show"></div>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // variant="primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i>{" "}
                    {actionFlagEmergencyContact == 1 ? "Update" : "Add"}
                  </Button>
                  <Button
                    // variant="danger light"
                    variant="danger btn-sm"
                    onClick={() => setAddEmergencyContactModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={addQualificationModal}
          onHide={setAddQualificationModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikQualification}>
              <Form onSubmit={formikQualification.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Qualification</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setAddQualificationModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        label="Degree"
                        name="Degree"
                        placeholder={"Enter Degree"}
                        component={CustomInput}
                        maxLength={50}
                        required
                        onChange={(e) => {
                          formikQualification.setFieldValue(
                            "Degree",
                            capitalizeString(e?.target?.value),
                          );
                        }}
                      />
                    </Col>
                    {/* <Col lg={12}>
                      <Field
                        type="number"
                        label="Percentage (%)"
                        name="Percentage"
                        placeholder={"Enter Percentage (%)"}
                        component={CustomInput}
                        required
                        onChange={(e) => {
                          if (e?.target?.value > -1 && e.target?.value <= 100) {
                            formikQualification.setFieldValue(
                              "Percentage",
                              e?.target?.value
                            );
                          }
                        }}
                      />
                    </Col> */}
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // variant="primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i>{" "}
                    {actionFlagQualification == 1 ? "Update" : "Add"}
                  </Button>
                  <Button
                    // variant="danger light"
                    variant="danger btn-sm"
                    onClick={() => setAddQualificationModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default AddEmployee;
